import React from "react";

export default function LoginRegisterLayoutBuyer(props) {
  return (
    <React.Fragment>
      <div class="container-fluid">
        <div class="row">
          <div class="col-md-6 d-flex" style={{ alignItems: "center", justifyContent:'center' }}>
            <div className="row">
              {/* <div className="col-md-4"></div> */}
              <div className="col-md-12">{props.children}</div>
            </div>
          </div>
          {/* <div class="col-md-2"></div> */}
          <div class="col-md-6">
            <img
              src="/img/sidebarImageC.png"
              alt="no image"
              style={{
                height: "100vh",
                width: "100%",
                objectFit: "cover",
              }}
            />
          </div>
        </div>
      </div>
    </React.Fragment>
  );
}
